
export default {
  base_url:'http://localhost:2001',
   userinfo:{
     loginid:'',
     name:'',
     userid:'',
     mobile:'',
     position:'',
     departmentid:'',
     departmentname:'',
     companyid:''
   },
  wxemail:'',
  // loginid:'',
  // username:'',
  homeurl:'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe2d11ecb2d76d98e&redirect_uri=http://wapi2.yangzijiang.com/appindex/&response_type=code&scope=SCOPE&agentid= 1000084&state=STATE#wechat_redirect',
  secret:'kD4GbhT8XTRIf_HdvK3l9pRJjqu6vYUdEMVAepZW3tY'
}



// WEBPACK FOOTER //
// ./src/globle/globle.js